const INITIAL_STATE ={
  currentReport : {
    certifier: null,
    fileHash: null,
    date: null,
    transactionExplorerURL: null
  },
  loadingReport: false,
  isReportAuthentic: null,
}

const reportsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case 'CHECK_REPORT_START': 
      return { ...state,  loadingReport: true, isReportAuthentic: false }

    case 'CHECK_REPORT_SUCCESS':
      return { ...state,  currentReport: action.payload, loadingReport: false, isReportAuthentic: true }

    case 'CHECK_REPORT_FAIL':
      return { ...state, loadingReport: false, isReportAuthentic: false }

    case 'RESET_CHECK_REPORT':
      return { 
        ...state,
        currentReport : {
          certifier: null,
          fileHash: null,
          date: null,
          transactionExplorerURL: null
        },
        loadingReport: false,
        isReportAuthentic: null
      }

    default:
      return state

  }
}

export default reportsReducer;


// WEBPACK FOOTER //
// ./src/reducers/reportsReducer.js